import { defineComponent as _defineComponent } from 'vue'
import { Options, Vue } from 'vue-class-component';
import { Toast } from 'vant';
import { useRoute, useRouter } from 'vue-router';
import { postIdCardInfo } from '@/api/miscellaneous';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReaLName',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const router = useRouter();

const detail = ref<any>({
    username: '',
    idcard: '',
});

console.log(router.currentRoute.value.query);


const isCheck = ref(false);

const goback = () => {
    //router.push({name: 'SellerShop', query: {id: $props}});
};

const submit = () => {


    if (!isCheck.value) {
        Toast.fail('请选择同意协议！');
        return;
    }
    if (detail.value.username == '') {
        Toast.fail('请输入姓名！');
        return;
    }
    if (detail.value.idcard == '' || (detail.value.idcard.length != 18 && detail.value.idcard.length != 15)) {
        Toast.fail('请输入正确的身份证号码,长度不正确！');
        return;
    }
    var regExp = /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[Xx\d]$/;
    if (!regExp.test(detail.value.idcard)) {
        Toast.fail('请输入正确的身份证号码！');
        return;
    }
    const data = {
        name: detail.value.username,
        idcard: detail.value.idcard
    };
    console.log(data);

    postIdCardInfo(data).then(res => {

        const { detailType, back, id, purchaseid } = router.currentRoute.value.query;
        if (back) {
            console.log(detailType);
            if (detailType == 'single' || detailType == 'project') {
                router.push({ name: "BuyDetail", query: { id: id } });
            } else if (detailType == 'wanttoby') {
                router.push({ name: "WantToBuy", query: {} });
            } else if (detailType == 'SupplyDetail') {
                router.push({ name: "SupplyDetail", query: { id: id } });
            } else if (detailType == "QuotedPriceList") {
                router.push({ name: "QuotedPriceList", query: { id: id, purchaseid: purchaseid } });
            }
        }
        Toast.success('保存成功');
        //引导到来源地

    });


}



const __returned__ = { route, router, detail, isCheck, goback, submit, Options, Vue, Toast, useRoute, useRouter, postIdCardInfo, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})